/* prettier-ignore */

import { Injectable, inject } from '@angular/core';
import { DataChatService } from './dataChat.service';
import { RequestService } from './request.service';
import { ScrollService } from './scrollContainer.service';
import { DebugService } from 'src/app/services/debug.service';
import { WebSocketService } from './webSocket.service';
import { AskStreamingService } from './ask-streaming.service';
import { environment } from 'src/environments/environment';
import { v4 as uuidv4 } from 'uuid';

@Injectable({ providedIn: 'root' })
export class SendMessageService {
  private webSocketService = inject(WebSocketService);
  private askStreamingService = inject(AskStreamingService);
  private debugService = inject(DebugService);

  public dataChat = inject(DataChatService);
  public request = inject(RequestService);
  public scrollService = inject(ScrollService);

  async sendMessageWebSocket(userInput: string, silent: boolean = false) {  
    //TODO: chek this
    this.dataChat.showRecommendedMessages.set(false);

    this.askStreamingService.sendAsk({ content: userInput });

    if (!silent) {
      this.dataChat.messages.update((prev) => [
        ...prev,
        {
          // id local: el @for del bubble trackea por message.id (HRS-3045)
          id: uuidv4(),
          role: 'user',
          content: userInput,
          show: true,
        },
      ]);

      setTimeout(() => {
        this.scrollService.scrollToBottom(true);
      }, 0);
    }
  }

  sendImageMessage(file: File, prompt?: string) {
    // HRS-3940: sin chatbot no se envía la imagen del visitante (antes salía `service` vacío).
    let serviceId: number;
    try {
      serviceId = this.dataChat.requireServiceId();
    } catch (err) {
      this.debugService.error(err, 'Imagen no enviada');
      this.dataChat.showConnectionErrorMessage();
      return;
    }

    const userContent = prompt ? `📷 [Imagen] ${prompt}` : '📷 [Imagen enviada]';

    // 1. Mostrar imagen en el chat (Optimistic UI)
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.dataChat.messages.update((prev) => [
        ...prev,
        {
          id: uuidv4(),
          role: 'user',
          content: userContent,
          show: true,
          imageUrl: e.target.result // FIXED: Use imageUrl to match Message interface
        },
      ]);
      setTimeout(() => this.scrollService.scrollToBottom(true), 100);
    };
    reader.readAsDataURL(file);

    // 2. Preparar FormData
    const completionId = uuidv4();
    // HRS-3045 (bloque 4): la respuesta de la imagen llega por el WS; garantizar conexión
    this.webSocketService.ensureConnected();
    this.webSocketService.trackCompletionId(completionId);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('user_id', this.dataChat.token() as string);
    formData.append('service', String(serviceId));
    formData.append('completion_id', completionId);
    if (prompt) {
      formData.append('prompt', prompt);
    }

    this.dataChat.chatIsThinking.set(true);
    this.dataChat.isStreaming.set(true);

    // 3. Enviar al Backend
    this.request.sendImage(formData).subscribe({
      next: (event: any) => {
        // Aquí podríamos manejar el progreso si fuera necesario
        // La respuesta final llegará vía SSE/WebSocket igual que el texto
      },
      error: (err) => {
        this.debugService.error(err, 'Error uploading image');
        this.dataChat.chatIsThinking.set(false);
        this.dataChat.isStreaming.set(false);
        this.dataChat.messages.update((prev) => [
          ...prev,
          {
            id: uuidv4(),
            content: 'Error al enviar la imagen. Inténtalo de nuevo.',
            role: 'assistant',
            show: true,
            danger: true,
          },
        ]);
      },
      complete: () => {
        // El worker procesará la imagen y responderá por el canal habitual
      }
    });
  }
}
